import { render, staticRenderFns } from "./UsuarioAM.vue?vue&type=template&id=22af4f22&scoped=true&"
import script from "./UsuarioAM.vue?vue&type=script&lang=js&"
export * from "./UsuarioAM.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioAM.vue?vue&type=style&index=0&id=22af4f22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22af4f22",
  null
  
)

export default component.exports